import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../helpers/reselectHelpers';
import {LocalPreferencesSizesEnum} from '../../models/api/localPreferencesModel';
import {updateSizeAction} from '../../store/data/localPreferences/localPreferencesActions';
import {
  createOrUpdateCalendarEventDraftAction,
  navigateCalendarsAction,
} from '../../store/panels/calendars/calendarsPanelActions';
import {makeGetCanCreateNewEvent} from '../../store/panels/calendars/calendarsPanelSelectors';
import {getWorkspacesWidth} from '../../store/panels/panelsSelectors';
import {CalendarsPanelId} from '../../store/panels/panelStateBase';
import {inLegacyTransientPanel} from '../legacyTransientPanel';
import {TabLargeCalendars} from './tabLargeCalendars';

/*
 * Props.
 */

interface TabLargeCalendarContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TabLargeCalendarContainerProps>()(() => ({
  canCreateNewEvent: makeGetCanCreateNewEvent(),
  workspacesWidth: getWorkspacesWidth,
}));

const mapDispatchToProps = makeMapDispatchToProps<TabLargeCalendarContainerProps>()(({panelId}) => ({
  onNewEventClick: () => createOrUpdateCalendarEventDraftAction(panelId),
  onWorkspacesWidthChange: (newWidth: number) =>
    updateSizeAction(LocalPreferencesSizesEnum.WORKSPACES, newWidth),
}));

export const TabLargeCalendarsContainer = inLegacyTransientPanel(
  connect(mapStateToProps, mapDispatchToProps)(TabLargeCalendars),
  ({panelId}) => navigateCalendarsAction(panelId),
);
